module.exports = __webpack_public_path__ + "static/media/hero_bg_lr.4b160d30.jpg";